module.exports = __webpack_public_path__ + "img/sort-icon-asc.9850723d.svg";